

import { createContext } from 'react';


const theme = createContext({});
const { Provider } = theme;

export {
  theme,
  Provider as ThemeProvider };